<template>
  <n-layout-footer>
    <n-p>&copy; {{ new Date().getFullYear() }} AGROFULL. Todos los derechos reservados.</n-p>
  </n-layout-footer>
</template>

<style scoped>
.n-layout-footer {
  position: absolute;
  bottom: 0;
  width: 100%;
  background: #F4F4F4;
  padding: 30px;
  text-align: center;
}
.n-a {
  text-decoration: none;
}
</style>